import { Injectable } from '@angular/core';
import { Util } from '../../core/util';

declare let ga: any;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  public Util: Util;

  constructor() {
    this.Util = new Util();
  }

  loadGoogleAnalyticsScript(): void {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-KK5S4VMW';
    document.head.appendChild(script);
  }

  logNavigationEvent(event: any): void {
    if (event?.urlAfterRedirects) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: 'page_view',
        page_path: event.urlAfterRedirects,
      });
    }
  }
}
